import { Box } from '@mui/material';
import TableCard from 'lib/designSystem/Card/TableCard';
import { formatDate } from 'lib/functions/utils';
import { SummaryRow } from 'pages/Finance/Components/Financing/common/Summary';
import React from 'react';

import { PayOutRequest } from '../../../../../types';

interface DetailsSummaryProps {
  request: PayOutRequest;
}

const DetailsSummary: React.FC<DetailsSummaryProps> = ({ request }) => {
  let businessName = '';
  let businessIdentifier = '';

  switch (request.source) {
    case 'payment-request-passive':
      businessName = request.pendingAccounts?.[0]?.businessName || '';
      businessIdentifier =
        request.pendingAccounts?.[0]?.businessIdentifier || '';
      break;
    case 'factoring-request':
    case 'credit-request':
      businessName = request.businessName || '';
      businessIdentifier = request.businessIdentifier || '';
      break;
    case 'payment-request':
      businessName = request.documents?.[0]?.businessName || '';
      businessIdentifier = request.documents?.[0]?.businessIdentifier || '';
      break;
    default:
      break;
  }

  return (
    <TableCard
      size="medium"
      enabledEffects={false}
      sx={{ boxShadow: 'none', border: 'none', background: 'transparent' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SummaryRow
          label="Destinatario"
          value={businessName}
          valueMaxLength={40}
        />
        <SummaryRow label="Rut cliente" value={businessIdentifier} />
        <SummaryRow
          label="Fecha de solicitud"
          value={formatDate(request.createdAt, 'dd-mm-yyyy')}
        />
      </Box>
    </TableCard>
  );
};

export default DetailsSummary;
